import {ReactNode, useLayoutEffect, useRef} from "react";
import {prerendering} from "../../components/prerendering";

// Fades and lifts its children in as they scroll into view (site.css: .reveal-hidden, .reveal-shown). Only what's below
// the screen when it first renders is hidden, so nothing on screen flashes; without IntersectionObserver, or for
// visitors who ask for less motion, it's simply shown. Nor while prerendering: the saved page (for search engines, and
// visitors before the app loads) has everything visible.
export function Reveal({children, className = ''}: { children: ReactNode, className?: string }) {
    const ref = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        const element = ref.current;
        if (!element || prerendering() || typeof IntersectionObserver === 'undefined' || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
            return;
        }
        if (element.getBoundingClientRect().top < window.innerHeight) {
            return;
        }
        element.classList.add('reveal-hidden');
        const observer = new IntersectionObserver(entries => {
            if (entries.some(x => x.isIntersecting)) {
                element.classList.add('reveal-shown');
                element.classList.remove('reveal-hidden');
                observer.disconnect();
            }
        }, { threshold: 0.12 });
        observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return <div ref={ref} className={className}>{children}</div>;
}
